import {
  IRegInvestAmountResponse,
  IRegInvestSavingsResponse,
} from '../services/types'

export const savingsInitResponse: IRegInvestSavingsResponse = {
  cumulativeAmount: null,
  estimatedAmount: null,
  annualReturn: null,
  productName: null,
  productId: null,
}

export const amountInitResponse: IRegInvestAmountResponse = {
  targetAmount: null,
  cumulativeAmount: null,
  estimatedAmount: null,
  annualReturn: null,
  productName: null,
  productId: null,
}
